<template>
  <!-- Drag the handle across two photos (before-after, style "slider"). A
     real range input does the work, so keyboard and screen readers can use it;
     the server render shows the halfway point. -->
  <div class="s2-bas">
    <div class="s2-bas__frame">
      <img :src="afterSrc" v-bind="imgAttrs(afterSrc, '(min-width: 1024px) 60vw, 100vw')" :alt="labels.after" class="s2-bas__img t-photo" loading="lazy" />
      <img :src="beforeSrc" v-bind="imgAttrs(beforeSrc, '(min-width: 1024px) 60vw, 100vw')" :alt="labels.before" class="s2-bas__img t-photo" loading="lazy" :style="{clipPath: `inset(0 ${100 - pos}% 0 0)`}" />
      <span class="s2-bas__line" :style="{left: pos + '%'}" aria-hidden="true"><span class="s2-bas__knob">⇆</span></span>
      <span class="t-badge s2-bas__tag s2-bas__tag--l">{{ labels.before }}</span>
      <span class="t-badge s2-bas__tag s2-bas__tag--r">{{ labels.after }}</span>
      <input class="s2-bas__range" type="range" min="0" max="100" v-model.number="pos" :aria-label="`Slide between ${labels.before.toLowerCase()} and ${labels.after.toLowerCase()}`" />
    </div>
  </div>
</template>

<script setup>
import {imgAttrs} from "@/utils/photoSizes.js";
import {computed, ref} from "vue";
import {mediaOf} from "@/utils/blocks.js";

const props = defineProps({
  before: {type: [Object, String], default: null},
  after: {type: [Object, String], default: null},
  labels: {type: Object, default: () => ({before: "Before", after: "After"})},
});
const pos = ref(50);
const beforeSrc = computed(() => mediaOf(props.before).src);
const afterSrc = computed(() => mediaOf(props.after).src);
</script>

<style scoped>
.s2-bas__frame { position: relative; aspect-ratio: 4 / 3; overflow: hidden; border-radius: var(--t-photo-radius, var(--t-radius)); }
.s2-bas__img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; border-radius: 0; }
.s2-bas__line { position: absolute; top: 0; bottom: 0; width: 3px; margin-left: -1.5px; background: #fff; pointer-events: none; }
.s2-bas__knob { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 40px; height: 40px; border-radius: 999px; background: #fff; color: #222; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 8px rgba(0,0,0,.3); font-weight: 800; }
.s2-bas__tag { position: absolute; top: .6rem; }
.s2-bas__tag--l { left: .6rem; } .s2-bas__tag--r { right: .6rem; }
.s2-bas__range { position: absolute; inset: 0; width: 100%; height: 100%; opacity: 0; cursor: ew-resize; margin: 0; }
.s2-bas__frame:focus-within { outline: 3px solid color-mix(in srgb, var(--t-accent) 55%, transparent); outline-offset: 3px; }
</style>
